var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
/* tslint:disable:jsx-no-multiline-js */
import classnames from 'classnames';
import React from 'react';
import TouchFeedback from 'rmc-feedback';
import Icon from '../icon';
class ChildBoard extends React.Component {
    constructor(props) {
        super(props);
        this.renderNumAndText = (text, number, onlyOneChild, textColor, numColor) => {
            const { error, isNotOverNum, unit } = this.props;
            const baseCls = this.props.prefixCls;
            // const textElm = <div className={`${baseCls}-boards-list-content-text`} style={{color: textColor}}>{text && text.length > 6 ? `${text.slice(0,6)}...` : text}</div>;
            const textElm = <div className={`${baseCls}-boards-list-content-text`} style={{ color: textColor }}>{text}</div>;
            let numberInner;
            if (number === '' || typeof number === 'undefined') {
                numberInner = (<Icon type="loading"/>);
            }
            else {
                numberInner = isNotOverNum && Number(number) > 99 ? "99+" : number;
            }
            if (error) {
                numberInner = '-';
            }
            const numberElm = <div className={`${baseCls}-boards-list-content-number`} style={{ color: numColor }}>
        <span className={`${baseCls}-boards-list-content-number-text`}>{numberInner}</span>
        {unit ? <span className={`${baseCls}-boards-list-content-number-unit`}>{unit}</span> : null}
        </div>;
            if (onlyOneChild) {
                return (<div>
          {textElm}
          {numberElm}
        </div>);
            }
            else {
                return (<div>
          {numberElm}
          {textElm}
        </div>);
            }
        };
        this.isRenderLine = (index, isShowDivideLine) => {
            if (isShowDivideLine) {
                if (index > 0) {
                    return <div className={`${this.props.prefixCls}-boards-list-divide-line`}></div>;
                }
            }
        };
        this.state = {};
    }
    render() {
        const _a = this.props, { prefixCls, children, isOnlyOneChild, text, number, extraText, textColor, numColor, index, isShowDivideLine, isShowRedSpot, onClick } = _a, restProps = __rest(_a, ["prefixCls", "children", "isOnlyOneChild", "text", "number", "extraText", "textColor", "numColor", "index", "isShowDivideLine", "isShowRedSpot", "onClick"]);
        const wrapCls = classnames(`${prefixCls}-boards-list-content`, {});
        const onlyOneChild = Number(isOnlyOneChild) === 1;
        return (<TouchFeedback activeClassName="bs-number-boards-boards-list-content-active">
        <div className={wrapCls} onClick={onClick} {...restProps}>
          {this.isRenderLine(index, isShowDivideLine)}
          <div style={{ display: isShowRedSpot ? "block" : "none" }} className={`${prefixCls}-boards-list-content-red-spot`}></div>
          <div className={onlyOneChild ? `${prefixCls}-boards-list-only-one` : ""}>
            {this.renderNumAndText(text, number, onlyOneChild, textColor, numColor)}
            <div style={{ display: onlyOneChild ? "inline-block" : "none" }} className={`${prefixCls}-boards-list-content-extra`}>
              {extraText}
            </div>
          </div>
        </div>
      </TouchFeedback>);
    }
}
ChildBoard.defaultProps = {
    prefixCls: 'bs-number-boards',
};
export default ChildBoard;



// WEBPACK FOOTER //
// ./components/boards/board.tsx